import { styled } from "@mui/material";

export const Container = styled("div")(() => ({
  display: "flex",
  flexDirection: "column",
  width: "100%",
  margin: "0 0 16px",
  gap: "16px",
}));

export const ButtonsContainer = styled("div")(() => ({
  marginBottom: "16px",
}));

export const SkeletonContainer = styled("div")(() => ({
  display: "flex",
  gap: "20px",
  flexDirection: "column",
  border: "1px solid #E0E0E0",
  borderRadius: "8px",
  padding: "16px",
}));
